import generateRandomString from '../../generateRandomString';

export function getBlock({ text, inlineStyleRanges = [], entityRanges = [] }) {
  return {
    data: {},
    depth: 0,
    entityRanges,
    inlineStyleRanges,
    key: generateRandomString(5),
    text,
    type: 'unstyled',
  };
}
